import { createLazyReactDirective } from '../../../shell/createLazyReactDirective';

export default createLazyReactDirective(
  async () => (await import('./EasyBusySettings')).EasyBusySettings,
  'easyBusySettings',
);
